import axios from "axios";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import SearchDropdown from "../../../components/Dropdowns/SearchDropdown";
import TypeChangeWarningModal from "./TypeChangeWarningModal";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";


const AddKeyContractData = ({ showModal, formData, search, disable, error, onSetFormData, onSetError, handleSubmit, handleClose }) => {
    const [config] = useAuth();
    const { id } = useParams();
    const navigate = useNavigate();
    const [companyOptions, setCompanyOptions] = useState([]);
    const [contactData, setContactData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [onbuyerOptions, onSetBuyerOptions] = useState([])
    const [onsellerOptions, onSetSellerOptions] = useState([])
    const [isSidebarOpen, setIsSidebarOpen] = useState(false)
    const [typeChangeWarning, setTypeChangeWarning] = useState({ show: false, index: null, section: null, selectedType: null });

    const confirmTypeChange = () => {
        const { index, section, selectedType } = typeChangeWarning;
        const updated = Array.isArray(formData[section]) ? [...formData[section]] : [];
        
        updated[index] = {
            ...updated[index],
            [`${section === 'sellers' ? 'seller' : 'buyer'}_type`]: selectedType,
            [`${section === 'sellers' ? 'seller' : 'buyer'}_id`]: [],
            [`${section === 'sellers' ? 'seller' : 'buyer'}_name`]: [],
        };
        
        onSetFormData({ ...formData, [section]: updated });
        if (section === 'sellers') fetchSeller("", selectedType);
        if (section === 'buyers') fetchBuyer("", selectedType);
        
        setTypeChangeWarning({ show: false, index: null, section: null, selectedType: null });
    };

    const fetchSuggestions = (inputValue) => {
        if (inputValue !== "") {
            const encodedInputValue = encodeURIComponent(inputValue);
            axios
                .get(`${BASE_URL}/get-datalisting?list=companies&search=${encodedInputValue}`, config)
                .then((res) => {
                    const value = res?.data?.data?.company_list;
                    setCompanyOptions(
                        value?.map((data) => ({
                            value: data.id,
                            label: data.company_name,
                        }))
                    );
                })
                .catch((err) => {
                    if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
                        NotificationManager.error(err.response?.data?.message);
                    }
                });
        } else {
            setCompanyOptions([]);
            onSetFormData({ ...formData, company_name: "", company: "" });
        }
    };

    const fetchcontactSuggestions = (inputValue) => {
        const companyId = formData?.company;

        axios
            .get(
                `${BASE_URL}/get-datalisting?list=contacts&search=${inputValue}&company_id=${companyId}`,
                config
            )
            .then((res) => {
                const data = res?.data?.data?.contact_list;
                const options = data.map((contact) => ({
                    value: contact.id,
                    label: `${contact.first_name} ${contact.last_name}`,
                }));
                setContactData(options);
            })
            .catch((err) => {
                if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
                    NotificationManager.error(err.response?.data?.message);
                }
            });
    };

    const fetchBuyer = (inputValue, type) => {
        let list = "acquisition";
        if (type === "Broker Inside") {
              list = "users&role_id=3";
        }
        axios
            .get(`${BASE_URL}/get-datalisting?list=${list}&search=${inputValue}`, config)
            .then((res) => {
                let leads = res.data?.data?.leads || res.data?.data?.contact_list;
                if (!leads && Array.isArray(res.data?.data)) {
                    leads = res.data?.data;
                } else if (!leads && res.data?.data && typeof res.data.data === 'object') {
                    leads = Object.values(res.data.data).find(val => Array.isArray(val)) || [];
                } else if (!leads) {
                    leads = [];
                }
                const options = leads.map((el) => {
                    const fullName = `${el?.first_name || ""} ${el?.last_name || ""}`.trim();
                    const label = el?.contact_name_full || fullName || el?.name || el?.email || `User ${el?.id}`;
                    return {
                        label,
                        value: el?.id,
                        contact_id: el?.contact_id,
                        contact_name: el?.contact_name_full,
                    };
                });
                onSetBuyerOptions(options);
            })
            .catch((err) => {
                if (
                    err.response?.data?.message &&
                    err.response?.data?.message !== "Too Many Attempts."
                ) {
                    NotificationManager.error(err.response?.data?.message);
                }
            });
    };


    const fetchSeller = (inputValue, type) => {
        let list = "contacts";
        if (type === "Broker Inside") {
            list = "users&role_id=3";
        }

        axios
            .get(`${BASE_URL}/get-datalisting?list=${list}&search=${inputValue}`, config)
            .then((res) => {
                let sellers = res.data?.data?.contact_list;
                if (!sellers && Array.isArray(res.data?.data)) {
                    sellers = res.data?.data;
                } else if (!sellers && res.data?.data && typeof res.data.data === 'object') {
                    sellers = Object.values(res.data.data).find(val => Array.isArray(val)) || [];
                } else if (!sellers) {
                    sellers = [];
                }
                const options = sellers.map((el) => {
                    const fullName = `${el?.first_name || ""} ${el?.last_name || ""}`.trim();
                    const label = el?.contact_name_full || fullName || el?.name || el?.email || `User ${el?.id}`;
                    return {
                        label,
                        value: el?.id,
                    };
                });
                onSetSellerOptions(options)
            })
            .catch((err) => {
                if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
                    NotificationManager.error(err.response?.data?.message)
                }
            })
    }

    useEffect(() => {
        if (isSidebarOpen) {
            fetchBuyer("", "")
            fetchSeller("", "")
        }
    }, [isSidebarOpen, formData?.portfolio])

    return (
        <form onSubmit={handleSubmit}>

            <div className="mt-6">
                <label className="dark-H head-4 ">Escrow Agent Company</label>
                <div className="mt-1.5 flex-1">
                    <SearchDropdown
                        isTop={false}
                        onChange={(e) =>
                            onSetFormData((prev) => ({
                                ...prev,
                                company_name: e.target.value,
                                company: e.target.value,
                            }))
                        }
                        placeholder="Search Escrow Agent Company Here"
                        text={formData?.company_name}
                        options={companyOptions}
                        fetchSuggestions={fetchSuggestions}
                        onSetOptions={(value) => setCompanyOptions(value)}
                        handleSelect={(option) => {
                            onSetError({ ...error, company: "" });
                            onSetFormData({
                                ...formData,
                                company_name: option?.label,
                                company: option?.value,  // <-- This is correct
                            });
                            setCompanyOptions([]);
                        }}
                    />


                </div>
            </div>

            <div className="mt-6">
                <p className="head-4 dark-H">Escrow Agent Name</p>

                <div className="mt-2">
                    <SearchDropdown
                        isTop={false}
                        placeholder={`Search Escrow Agent Name`}
                        text={formData?.contact?.name}
                        options={contactData}
                        fetchSuggestions={fetchcontactSuggestions}
                        onSetOptions={(value) => setContactData(value)}
                        handleSelect={(option) => {
                            onSetFormData({
                                ...formData,
                                contact: { id: option?.value, name: option?.label },
                            });
                            setContactData([]);
                        }}
                    />
                </div>
            </div>

            <div className="mt-6">
                <label className="dark-H head-4 mb-2">Seller</label>

                {(formData.sellers?.length ? formData.sellers : [{}]).map((item, index) => (
                    <div key={index} className="flex gap-4 items-center mb-3">


                        <div className="flex-1">
                            <Select
                                className="body-N"
                                placeholder="Search Sellers"
                                isMulti
                                options={onsellerOptions}
                                onMenuOpen={() => {
                                    const currentType = formData.sellers[index]?.seller_type || "";
                                    if (!currentType) {
                                        NotificationManager.warning("Please select a Type first");
                                    }
                                    fetchSeller("", currentType);
                                }}

                                onInputChange={(value, action) => {
                                    if (action.action === "input-change") {
                                        const currentType = formData.sellers[index]?.seller_type || "";
                                        fetchSeller(value, currentType);
                                    }
                                }}
                                noOptionsMessage={() => 
                                    !formData.sellers[index]?.seller_type 
                                        ? "Please select a Type first" 
                                        : "No options found"
                                }

                                value={
                                    Array.isArray(item?.seller_id)
                                        ? item.seller_id.map((id, idx) => ({
                                            value: id,
                                            label: item?.seller_name?.[idx] || ""
                                        }))
                                        : []
                                }

                                onChange={(selected) => {
                                    const updated = [...(formData.sellers || [])];

                                    updated[index] = {
                                        ...updated[index],
                                        seller_id: selected?.map((s) => s.value) || [],
                                        seller_name: selected?.map((s) => s.label) || [],
                                    };

                                    onSetFormData({ ...formData, sellers: updated });
                                }}
                            />

                        </div>



                        {/* TYPE Dropdown */}
                        <div className="flex-1">
                            <Select
                                className="body-N"
                                placeholder="Select Type"
                                options={[
                                    { value: "Broker Inside", label: "Broker Inside" },
                                    { value: "Broker Outside", label: "Broker Outside" },
                                    { value: "BDS", label: "BDS" },
                                    { value: "Attorney", label: "Attorney" },
                                    { value: "Business Partner", label: "Business Partner" },
                                    { value: "Seller", label: "Seller" },
                                    { value: "Other", label: "Other" },
                                ].filter((opt) => {
                                    const sellers = Array.isArray(formData?.sellers)
                                        ? formData.sellers
                                        : [];

                                    return !sellers
                                        .filter((_, i) => i !== index)
                                        .some((row) => row?.seller_type === opt.value);
                                })}
                                value={
                                    item?.seller_type
                                        ? { value: item.seller_type, label: item.seller_type }
                                        : null
                                }
                                onChange={(selected) => {
                                    if (item?.seller_id?.length > 0) {
                                        setTypeChangeWarning({ show: true, index, section: 'sellers', selectedType: selected.value });
                                    } else {
                                        const updated = Array.isArray(formData.sellers)
                                            ? [...formData.sellers]
                                            : [];

                                        updated[index] = {
                                            ...updated[index],
                                            seller_type: selected.value,
                                            seller_id: [],
                                            seller_name: [],
                                        };

                                        onSetFormData({ ...formData, sellers: updated });
                                        fetchSeller("", selected.value);
                                    }
                                }}
                                styles={{
                                    menuList: (base) => ({
                                        ...base,
                                        maxHeight: "10rem",   // Tailwind h-40 equivalent
                                        overflowY: "auto",
                                    }),
                                }}
                            />

                        </div>


                        {/* Add button (+) */}
                        <button
                            type="button"
                            className="text-[30px] text-gray-500"
                            onClick={() => {
                                onSetFormData({
                                    ...formData,
                                    sellers: [
                                        ...(formData.sellers || [{}]),
                                        { seller_id: "", seller_name: "", seller_type: "" }
                                    ]
                                });
                            }}
                        >
                            +
                        </button>

                        {/* Remove button (X)*/}
                        <button
                            type="button"
                            className="text-xl text-gray-500"
                            onClick={() => {
                                const updated = [...formData.sellers];
                                if (updated.length > 1) updated.splice(index, 1);
                                onSetFormData({ ...formData, sellers: updated });
                            }}
                        >
                            ✕
                        </button>
                    </div>
                ))}

                {error?.seller && <span className="body-S red-D">{error?.seller}</span>}
            </div>

            <div className="mt-6">
                <label className="dark-H head-4 mb-2">Buyer</label>

                {(formData.buyers?.length ? formData.buyers : [{}]).map((item, index) => (
                    <div key={index} className="flex gap-4 items-center mb-3">

                        <div className="flex-1">
                            <Select
                                className="body-N"
                                placeholder="Search Buyers"
                                isMulti
                                options={onbuyerOptions}
                                onMenuOpen={() => {
                                    const currentType = formData.buyers[index]?.buyer_type || "";
                                    if (!currentType) {
                                        NotificationManager.warning("Please select a Type first");
                                    }
                                    fetchBuyer("", currentType);
                                }}

                                onInputChange={(value, action) => {
                                    if (action.action === "input-change") {
                                        const currentType = formData.buyers[index]?.buyer_type || "";
                                        fetchBuyer(value, currentType);
                                    }
                                }}
                                noOptionsMessage={() => 
                                    !formData.buyers[index]?.buyer_type 
                                        ? "Please select a Type first" 
                                        : "No options found"
                                }

                                value={
                                    Array.isArray(item?.buyer_id)
                                        ? item.buyer_id.map((id, idx) => ({
                                            value: id,
                                            label: item?.buyer_name?.[idx] || ""
                                        }))
                                        : []
                                }

                                onChange={(selected) => {
                                    const updated = [...(formData.buyers || [])];

                                    updated[index] = {
                                        ...updated[index],
                                        buyer_id: selected?.map((s) => s.value) || [],
                                        buyer_name: selected?.map((s) => s.label) || [],
                                    };

                                    onSetFormData({ ...formData, buyers: updated });
                                }}
                            />
                        </div>

                        {/* TYPE Dropdown */}
                        <div className="flex-1">
                            <Select
                                className="body-N"
                                placeholder="Select Type"
                                options={[
                                    { value: "Broker Inside", label: "Broker Inside" },
                                    { value: "Broker Outside", label: "Broker Outside" },
                                    { value: "BDS", label: "BDS" },
                                    { value: "Attorney", label: "Attorney" },
                                    { value: "Business Partner", label: "Business Partner" },
                                    { value: "Buyer", label: "Buyer" },
                                    { value: "Other", label: "Other" },
                                ].filter((opt) => {
                                    const buyers = Array.isArray(formData?.buyers)
                                        ? formData.buyers
                                        : [];

                                    return !buyers
                                        .filter((_, i) => i !== index)
                                        .some((row) => row?.buyer_type === opt.value);
                                })}
                                value={
                                    item?.buyer_type
                                        ? { value: item.buyer_type, label: item.buyer_type }
                                        : null
                                }
                                onChange={(selected) => {
                                    if (item?.buyer_id?.length > 0) {
                                        setTypeChangeWarning({ show: true, index, section: 'buyers', selectedType: selected.value });
                                    } else {
                                        const updated = Array.isArray(formData.buyers)
                                            ? [...formData.buyers]
                                            : [];

                                        updated[index] = {
                                            ...updated[index],
                                            buyer_type: selected.value,
                                            buyer_id: [],
                                            buyer_name: [],
                                        };

                                        onSetFormData({ ...formData, buyers: updated });
                                        fetchBuyer("", selected.value);
                                    }
                                }}
                                classNames={{
                                    menuList: () => "max-h-40 overflow-y-auto", // 👈 scroll added
                                }}
                            />

                        </div>


                        {/* Add button (+) */}
                        <button
                            type="button"
                            className="text-[30px] text-gray-500"
                            onClick={() => {
                                onSetFormData({
                                    ...formData,
                                    buyers: [
                                        ...(formData.buyers || [{}]),
                                        { buyer_id: "", buyer_name: "", buyer_type: "" }
                                    ]
                                });
                            }}
                        >
                            +
                        </button>

                        {/* Delete button (X) */}
                        <button
                            type="button"
                            className="text-xl text-gray-500"
                            onClick={() => {
                                const updated = [...formData.buyers];
                                if (updated.length > 1) updated.splice(index, 1);

                                onSetFormData({ ...formData, buyers: updated });
                            }}
                        >
                            ✕
                        </button>
                    </div>
                ))}

                {error?.buyer && <span className="body-S red-D">{error?.buyer}</span>}
            </div>


            <div className="mt-6">
                <button type="submit" disabled={disable} className="save-button light-L head-5 green-bg-H">
                    Save
                </button>
                <button type="button" onClick={handleClose} className="green-H ml-5">
                    Cancel
                </button>
            </div>

            <TypeChangeWarningModal
                show={typeChangeWarning.show}
                onConfirm={confirmTypeChange}
                onCancel={() => setTypeChangeWarning({ show: false, index: null, section: null, selectedType: null })}
            />
        </form>
    );
};

export default AddKeyContractData;